<template>
  <ErrorDisplay :message="error?.message" @retry="reloadStorageData" :loading="loading" />
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import ErrorDisplay from './ErrorDisplay.vue';
import {storeMap} from '@/plugins/piniaStoreById';

const props = defineProps({
  module: {
    type: String,
    required: true,
    default: () => null,
  },
});

const storeFromId = storeMap.get(props.module);

const error = computed((): Error|null => {
  if (!storeFromId) return null;
  return storeFromId.error;
});

const loading =computed((): boolean => {
  if (!storeFromId) return true;
  return storeFromId.loading;
});
async function reloadStorageData() {
  if (storeFromId) {
    await storeFromId!.fetch();
  }
}

defineExpose({
  error,
  loading,
  reloadStorageData,
  ErrorDisplay,
});
</script>
